
<template>
  <TableTemplate
    class="CategoriesCollection"
    id="categories-collection"
    :class="{loading: isLoadingTableResult}"

    v-model="tableData"

    :columns="websiteColumns"
    :columnVariables="websiteColumnVariables"
    :capitalize="capitalize"
    :viewportHeight="viewportHeight"
    :removeSkeletonArray="removeSkeletonArray"
    :skeletonClass="skeletonClass"
    :remove-cursor="true"

    :white-bg="true"
    :hide-pagination="true"
    :disableLoadingContent="disableLoadingContent"
    :removeCardStyle="removeCardStyle"
    :heightLimit="heightLimit"
    :remove-table-header="!fullPage"

    :page="page"

    @update-column-order="updateColumnOrder"
    @set-page="v => page = v"

    :max="max"

    ref="table"
  >

    <div v-if="!fullPage" class="d-flex justify-content-between p-2">
      <slot name='header-title'>
        <div>
          <h4 class="card-title">
            Categorieën
          </h4>
          <div>
            <TableSearchField v-model="category"/>
          </div>
        </div>
      </slot>
      <HeaderButton v-if="editable"
        buttonTypeClass="btn-outline-primary btn-primary-secondary-outline"
        style="padding: 11px 8px"
        @click.native="addCategory"
      >
        Nieuw
      </HeaderButton>
    </div>
    <template v-if="fullPage" #above>
      <TableHeader v-model="selecting"
        title="Categorieën"
        :showButton="showButton"
        :alwaysShowMultiSelectCheckbox="false"
        :removeColumnConfiguration="true"
        :refetch="refetch"
        :exportParams="exportEndpointParams"

        @customize-layout="customizeLayout"
      >
        <template #header-buttons-before="props">
          <slot name="header-buttons-before" v-bind="props"></slot>
        </template>
        <template #after-title>
          <!-- <MultipleSelectOptions v-if="showButton" :options="editOptions(refetch)">
            <template #enable-selected>
              <svg xmlns="http://www.w3.org/2000/svg" class="button-icon" width="20" height="20" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v3m0 0v3m0-3h3m-3 0H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
            </template>
            <template #disable-selected>
              <svg xmlns="http://www.w3.org/2000/svg" class="button-icon" width="20" height="20" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
            </template>
          </MultipleSelectOptions> -->

          <HeaderButton class="ml-2"
            buttonTypeClass="btn-outline-primary btn-primary-secondary-outline"
            style="padding: 11px 8px"

            @click.native="addCategory"
          >
            Categorie toevoegen
          </HeaderButton>
        </template>
      </TableHeader>

      <div class="d-flex">
        <TableMainSearchField v-model="category"/>
        <RefreshBtn
          :loading="isLoadingTableResult"
          @click.native="refresh"
        />
      </div>
    </template>

    <template v-if="loaded && editable" #row-action="{item}">
      <div class="delete-icon base-delete-icon" @click="confirmDelete(item)">
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
        </svg>
      </div>
    </template>

    <template #cell-category="{value, item}">
      <span class="table-cell" :skeletonClass="!removeSkeletonClass ? skeletonClass : ''">
        <svg xmlns="http://www.w3.org/2000/svg" class="arrow-icon category-arrow-icon" width="18" height="18" viewBox="0 0 20 20" fill="currentColor"
          :class="{active: item && item.sub_categories && item.sub_categories.length, showing: showing_categories[item.uid]}"

          @click.prevent.stop="toggleSubCategories(item.uid)"
        >
          <path fill-rule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clip-rule="evenodd" />
        </svg>

        <slot name="before-category" :item="item"></slot>

        <span
          class="name category-name"
          :class="[
            editable,
          ]"

          @click="editable && editCategory(item)"
        >
          {{ value }}
        </span>

        <svg v-if="editable" xmlns="http://www.w3.org/2000/svg" class="text-primary ml-1 plus-icon" width="16" height="16" viewBox="0 0 20 20" fill="currentColor" @click.prevent.stop="addSubCategory(item)">
          <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-11a1 1 0 10-2 0v2H7a1 1 0 100 2h2v2a1 1 0 102 0v-2h2a1 1 0 100-2h-2V7z" clip-rule="evenodd" />
        </svg>

        <slot name="after-category" :loading="isLoadingTableResult" :item="item"></slot>

        <div v-if="!onlySubcategories && item && item.sub_categories && item.sub_categories.length && showing_categories[item.uid]" class="sub-categories">
          <div v-for="cat in item.sub_categories" :key="cat.uid"
            class="sub-category-row d-flex align-items-center"

            :remove-cursor="true"
            @click.stop.prevent="editable && editCategory(cat)"
          >
            <span class="table-cell sub-table-cell">
              <span class="sub-category-cell">
                <span>
                  <slot name="before-category" :item="cat" :isSubcategory="true"></slot>

                  {{ cat.category }}
                </span>

                <span class="after-category-wrapper">
                  <slot name="after-category" :loading="isLoadingTableResult" :item="cat" :isSubcategory="true"></slot>
                </span>
              </span>

              <div v-if="editable" class="delete-icon sub-category-delete-icon" @click.prevent.stop="confirmDelete(cat)">
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                </svg>
              </div>
            </span>
          </div>
        </div>
      </span>
    </template>

    <template #empty-state>
      <EmptyStatePlaceholder
        title="Er zijn geen categorieën"
      >
        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
          <path fill-rule="evenodd" d="M17.707 9.293a1 1 0 010 1.414l-7 7a1 1 0 01-1.414 0l-7-7A.997.997 0 012 10V5a3 3 0 013-3h5c.256 0 .512.098.707.293l7 7zM5 6a1 1 0 100-2 1 1 0 000 2z" clip-rule="evenodd" />
        </svg>
      </EmptyStatePlaceholder>
    </template>
  </TableTemplate>
</template>

<script>

import TableTemplate from 'src/layout/Table/TableTemplate'
import TableSearchField from "src/components/Inputs/TableSearchField.vue"
import TableActionDropdown from "src/components/Inputs/TableActionDropdown.vue"
import EmptyStatePlaceholder from "src/layout/EmptyStatePlaceholder.vue"
import HeaderButton from "src/components/Inputs/HeaderButton.vue"
import TableHeader from '../components/Product/ProductTable/TableHeader.vue'
import TableMainSearchField from '../layout/TableMainSearchField.vue'
import RefreshBtn from '../layout/RefreshBtn.vue'

import table from "src/mixins/table"
import tableFieldOptions from "src/mixins/tableFieldOptions"
import selectMultipleItems from "src/mixins/selectMultipleItems"

export default {
  components: {
    TableTemplate,
    TableSearchField,
    RefreshBtn,
    TableActionDropdown,
    TableHeader,
    EmptyStatePlaceholder,
    HeaderButton,
    TableMainSearchField,
  },
  mixins: [
    selectMultipleItems,
    tableFieldOptions,
    table({
      pageReference: 'categories',

      skeletonPlaceholderStr: "ash tnhaeissa htneot",
      disablePlaceholder: true,

      params: {
        category: "",
      },
      getParams: (params, vm) => ({
        ...params, format: "tree",
        sub_category: null,
      }),
      route: "/api/categories",
    }),
  ],
  props: {
    viewportHeight: Boolean,
    removeSkeletonClass: Boolean,
    disableLoadingContent: Boolean,
    removeSkeletonArray: Boolean,
    removeCardStyle: Boolean,
    heightLimit: String,
    fullPage: {
      type: Boolean,
      default: true,
    },

    disableRouterRedirects: {
      type: Boolean,
      required: false,
    },
    editable: {
      type: Boolean,
      default: true,
    },
    onlySubcategories: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showing_categories: {},
    }
  },
  methods: {
    async deleteCategory(uid) {
      await this.$handlePromise(
        this.axios.delete(`/api/categories/${uid}`)
      )
      this.$store.dispatch('clearCacheSearch', "accounts")
      this.$success("Productgroup succesvol verwijderd!")
      this.freshRefetch()
    },

    toggleSubCategories(uid) {
      const obj = this.showing_categories
      this.showing_categories = {
        ...obj,
        [uid]: !obj[uid],
      }
    },
    collapseSubCategory(uid) {
      const obj = this.showing_categories
      this.showing_categories = {
        ...obj,
        [uid]: true,
      }
    },
    addSubCategory(item) {
      if (!this.editable) return;

      this.$pushModal({
        modal: "EditCategory",
        toBind: {
          parent_id: item.uid,
          callback: async () => {
            this.freshRefetch()
          },
        },
      })
    },
    addCategory() {
      this.$pushModal({
        modal: "EditCategory",
        toBind: {
          callback: async () => {
            this.freshRefetch()
          },
        },
      })
    },
    editCategory(category) {
      this.$pushModal({
        modal: "EditCategory",
        toBind: {
          category,
          callback: async () => {
            this.freshRefetch()
          },
        },
      })
    },
    confirmDelete(item) {
      this.$confirmAction(
        () => this.deleteCategory(item.uid),
        {
          title: "Categorie verwijderen",
          description: `Are you sure you want to delete the <b>${item.category}</b> category?`,
          buttonSave: "Verwijderen",
        }
      )
    },
  },
  computed: {
    tableData() {
      const result = this.tableResult
      if (!result || typeof result === "string") return result

      if (this.onlySubcategories) return this.subCategories

      return result;
    },
    subCategories() {
      const result = this.tableResult
      if (result && typeof result !== "string") {
        return result.filter(cat => cat).map(cat => cat.sub_categories || []).flat()
      }
    },
    rootCategories() {
      const result = this.tableResult
      if (result && typeof result !== "string") {
        return result.filter(cat => cat)
      }
    },

    table() {
      return this.$refs.table
    },
    websiteColumns() {
      return ['Naam']
    },
    websiteColumnVariables() {
      return ['category']
    },
    capitalize() {
      return [false]
    },

    removeRouterDirect() {
      return this.disableRouterRedirects
    },
  },
  watch: {
    subCategories(subs) {
      this.$emit("sub-categories", subs)
    },
    rootCategories(roots) {
      this.$emit("root-categories", roots)
    },
  },
}

</script>

<style>

.CategoriesCollection .row-action {
  height: 30px !important;
}

.CategoriesCollection tr {
  border: none !important;
}

.CategoriesCollection .FormCheckbox {
  padding: 0 !important;
}

.CategoriesCollection .checkbox-wrapper {
  transform: translateY(-1px) !important;
  width: 30px !important;
}

.CategoriesCollection .ComposableTable {
  margin: 0px;
}

.CategoriesCollection .base-delete-icon {
  position: relative !important;
  margin-top: 4px;
  left: -4px;
}

</style>

<style scoped>

.sub-category-row {
  height: 30px;
}

.after-category-wrapper {
  position: absolute;
  right: -12px;
}

.arrow-icon, .plus-icon {
  cursor: pointer;
}

.plus-icon {
  margin-top: -.5px;
}

.editable .name {
  cursor: pointer;
  text-decoration: none !important;
}

.arrow-icon:hover {
  filter: brightness(2);
}

.arrow-icon {
  transition-duration: .2s;
  opacity: 0;
  transform: translateY(-1px);
}

.arrow-icon.active {
  opacity: 1;
}

.arrow-icon.showing {
  transform: rotate(90deg);
}

.sub-category-cell {
  display: flex;
  justify-content: space-between;
  position: relative;
  padding-left: 30px;
}

.delete-icon {
  margin-top: -6.5px;
}

.sub-categories .delete-icon {
  position: absolute;
  right: 0;
  height: 30px;
  margin-top: -14px;
  margin-right: 9px;
}

.icon-wrapper {
  position: relative;
  border-left: 1px solid rgba(0, 0, 0, 0.125);
  color: #999999;
}

.table-search-wrapper {
  flex-grow: 1;
}


.table-main-search-field {
  max-width: 300px;
  background-color: white;
  border-radius: 1px;
  border: 1px solid rgba(0, 0, 0, 0.125);
  font-size: 13px;
}

@media (max-width: 800px) {
  .table-main-search-field {
    max-width: unset;
    width: 100%;
  }
}

</style>
